var styles = {
  "Line": "_Line_y7hzj_1"
};

export { styles as default };
